export default __webpack_public_path__ + "images/help-mobile.png";